export default __webpack_public_path__ + "static/media/galleryImg2.0a0b254c.png";